<template>
  <div style="overflow: hidden; position: relative;">
    <el-form :inline="true" :model="formInline" class="demo-form-inline" ref="formInline">
      <el-date-picker v-model="formInline.daterange" type="daterange" range-separator="至" start-placeholder="开始日期"
        end-placeholder="结束日期" size="large" value-format="yyyy-MM-dd">
      </el-date-picker>
      <el-form-item prop="statu">
        <el-select v-model="formInline.statu" placeholder="状态" size="large" clearable>
          <el-option v-for="item in status" :key="item.value" :label="item.lable" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="xmdddocno">
        <el-input v-model="formInline.xmdddocno" placeholder="订单单号" clearable></el-input>
      </el-form-item>
      <el-form-item prop="xmddseq">
        <el-input v-model="formInline.xmddseq" placeholder="项次" clearable></el-input>
      </el-form-item>
      <el-form-item prop="xmddseq1">
        <el-input v-model="formInline.xmddseq1" placeholder="项序" clearable></el-input>
      </el-form-item>
      <el-form-item prop="principal">
        <el-input v-model="formInline.principal" placeholder="计划负责人" clearable></el-input>
      </el-form-item>
      <el-form-item prop="sfaadocno">
        <el-input v-model="formInline.sfaadocno" placeholder="工单号" clearable></el-input>
      </el-form-item>
      <el-form-item prop="xmddua017">
        <el-input v-model="formInline.xmddua017" placeholder="产品信息单号" clearable></el-input>
      </el-form-item>
      <el-form-item prop="xmdaua001">
        <el-input v-model="formInline.xmdaua001" placeholder="子项目令号" clearable></el-input>
      </el-form-item>
      <el-form-item prop="pjabl003">
        <el-input v-model="formInline.pjabl003" placeholder="项目名称" clearable></el-input>
      </el-form-item>
      <el-form-item prop="createder">
        <el-input v-model="formInline.createder" placeholder="售中提报人" clearable></el-input>
      </el-form-item>
      <!--      <el-form-item prop="pmaal004">
        <el-input v-model="formInline.pmaal004" placeholder="客户名称" clearable></el-input>
      </el-form-item> -->
      <!--      <el-form-item prop="xmddua017">
        <el-input v-model="formInline.xmddua017" placeholder="产品信息单号" clearable></el-input>
      </el-form-item> -->
      <el-form-item style="margin-right: 0; white-space: nowrap;">
        <el-button type="primary" @click="onSearch('search')">查询</el-button>
        <el-button type="primary" plain @click="resetForm('formInline')">重置</el-button>
        <el-button type="primary" plain @click="reportTable">Excle导出</el-button>
        <!-- <el-button type="info" plain @click="drawer = true">更多条件查询</el-button> -->
      </el-form-item>
    </el-form>
    <el-table :data="tableData" style="width: 100%;" max-height="654" border v-loading="loading" ref="report-table">
      <el-table-column fixed prop="createder" label="售中提报人" width="100">
      </el-table-column>
      <el-table-column prop="createdTime" label="提报时间" width="180">
      </el-table-column>
      <el-table-column prop="xmdddocno" label="订单单号" width="180">
      </el-table-column>
      <el-table-column prop="hXmdadocno" label="合同据点订单单号" width="230">
      </el-table-column>
      <el-table-column prop="dPmdl008" label="采购多角来源订单单号" width="230">
      </el-table-column>
      <el-table-column prop="xmddseq" label="项次" width="60">
      </el-table-column>
      <el-table-column prop="xmddseq1" label="项序" width="60">
      </el-table-column>
      <el-table-column prop="xmda002" label="业务人员">
      </el-table-column>
      <el-table-column prop="xmdadocdt" label="订单日期" width="180">
      </el-table-column>
      <el-table-column prop="datecjtj" label="信息单下发日期" width="180">
      </el-table-column>
      <el-table-column prop="datejhtj" label="信息单计划审批日期" width="180">
      </el-table-column>
      <el-table-column prop="xmdaua001" label="子项目令号" width="260">
      </el-table-column>
      <el-table-column prop="pjabl003" label="项目名称" width="350">
      </el-table-column>
      <el-table-column prop="pmaal004" label="客户名称" width="260">
      </el-table-column>
      <el-table-column prop="xmdcua004" label="供应类型" width="160">
      </el-table-column>
      <el-table-column prop="rtaxuc003" label="标准产品名称" width="160">
      </el-table-column>
      <el-table-column prop="xmdcua018" label="公司细分产品名称" width="160">
      </el-table-column>
      <el-table-column prop="xmdcua006" label="产品型号" width="200">
      </el-table-column>
      <el-table-column prop="xmdd001" label="料件编号" width="160">
      </el-table-column>
      <el-table-column prop="imaal003" label="品名" width="160">
      </el-table-column>
      <el-table-column prop="imaal004" label="规格" width="420">
      </el-table-column>
      <el-table-column prop="xmddua017" label="产品信息单号" width="190">
      </el-table-column>
      <el-table-column prop="oocql004" label="产地">
      </el-table-column>
      <el-table-column prop="xmdd005" label="订单数量">
      </el-table-column>
      <el-table-column prop="xmdd031" label="已转出通量" width="100">
      </el-table-column>
      <el-table-column prop="xmdd014" label="已转出货量(考虑销退数量)" width="190">
      </el-table-column>
      <el-table-column prop="planNum" label="计划发货数量" width="120">
      </el-table-column>
      <el-table-column prop="planDate" label="计划发货日期" width="120">
        <template slot-scope="scope">
          {{scope.row.planDate?scope.row.planDate.substring(0, 10):''}}
        </template>
      </el-table-column>
      <el-table-column prop="planFeedbackTime" label="计划响应时间" width="160"></el-table-column>
      <el-table-column prop="principal" label="计划负责人" width="100"></el-table-column>
      <el-table-column prop="planDeliveryTime" label="预计发货日期" width="120">
        <template slot-scope="scope">
          {{scope.row.planDeliveryTime?scope.row.planDeliveryTime.substring(0, 10):''}}
        </template>
      </el-table-column>
      <el-table-column prop="actualDeliveryTime" label="修正发货日期" width="120">
        <template slot-scope="scope">
          {{scope.row.actualDeliveryTime?scope.row.actualDeliveryTime.substring(0, 10):''}}
        </template>
      </el-table-column>
      <el-table-column prop="sfaadocno" label="工单号" width="170"></el-table-column>
      <el-table-column label="单据日期" width="120">
        <template slot-scope="scope">
          {{scope.row.sfaadocdt?scope.row.sfaadocdt.substring(0, 10):''}}
        </template>
      </el-table-column>
      <el-table-column prop="oofa011" label="生管人员" width="80"></el-table-column>
      <el-table-column prop="sfaa019" label="预计开工日期" width="120">
        <template slot-scope="scope">
          {{scope.row.sfaa019?scope.row.sfaa019.substring(0, 10):''}}
        </template>
      </el-table-column>
      <el-table-column prop="sfaa020" label="预计完工日期" width="120">
        <template slot-scope="scope">
          {{scope.row.sfaa020?scope.row.sfaa020.substring(0, 10):''}}
        </template>
      </el-table-column>
      <el-table-column prop="sfaa012" label="生产数量" width="80"></el-table-column>
      <el-table-column prop="sfaa050" label="已入库合格量" width="110"></el-table-column>
      <el-table-column prop="sfaa046" label="最后入库日期" width="160"></el-table-column>
      <el-table-column fixed="right" label="操作" width="80" v-if="!noReport">
        <template slot-scope="scope">
          <el-button @click.native.prevent="seeDetail(scope.row)" icon="el-icon-view" type="text">
            查看
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @current-change="handleCurrentChange" :current-page="page" :page-size="rows"
      layout="total, prev, pager, next, jumper" :total="total">
    </el-pagination>
    <el-dialog title="查看详情页" :visible.sync="dialogVisible" width="80%" @close="handleClose"
      :modal-append-to-body="false" :append-to-body="true">
      <div class="cont-box">
        <p class="title">基本信息</p>
        <ul class="list-cont">
          <li>
            <label>售中提报人:</label>
            <p>{{curData.createder}}</p>
          </li>
          <li>
            <label>提报时间:</label>
            <p>{{curData.createdTime}}</p>
          </li>
          <li>
            <label>订单单号:</label>
            <p>{{curData.xmdddocno}}</p>
          </li>
          <li>
            <label>合同据点订单单号:</label>
            <p>{{curData.hXmdadocno}}</p>
          </li>
          <li>
            <label>采购多角来源订单单号:</label>
            <p>{{curData.dPmdl008}}</p>
          </li>
          <li>
            <label>项次:</label>
            <p>{{curData.xmddseq}}</p>
          </li>
          <li>
            <label>项序:</label>
            <p>{{curData.xmddseq1}}</p>
          </li>
          <li>
            <label>业务人员:</label>
            <p>{{curData.xmda002}}</p>
          </li>
          <li>
            <label>订单日期:</label>
            <p>{{curData.xmdadocdt}}</p>
          </li>
          <li>
            <label>信息单下发日期:</label>
            <p>{{curData.datecjtj}}</p>
          </li>
          <li>
            <label>信息单计划审批日期:</label>
            <p>{{curData.datejhtj}}</p>
          </li>
          <li>
            <label>子项目令号:</label>
            <p>{{curData.xmdaua001}}</p>
          </li>
          <li>
            <label>项目名称:</label>
            <p>{{curData.pjabl003}}</p>
          </li>
          <li>
            <label>客户名称:</label>
            <p>{{curData.pmaal004}}</p>
          </li>
          <li>
            <label>客户名称代码:</label>
            <p>{{curData.xmda022}}</p>
          </li>
          <li>
            <label>供应类型:</label>
            <p>{{curData.xmdcua004}}</p>
          </li>
          <li>
            <label>标准产品名称:</label>
            <p>{{curData.rtaxuc003}}</p>
          </li>
          <li>
            <label>公司细分产品名称:</label>
            <p>{{curData.xmdcua018}}</p>
          </li>
          <li>
            <label>产品型号:</label>
            <p>{{curData.xmdcua006}}</p>
          </li>
          <li>
            <label>料件编号:</label>
            <p>{{curData.xmdd001}}</p>
          </li>
          <li>
            <label>品名:</label>
            <p>{{curData.imaal003}}</p>
          </li>
          <li>
            <label>规格:</label>
            <p>{{curData.imaal004}}</p>
          </li>
          <li>
            <label>产品信息单号:</label>
            <p>{{curData.xmddua017}}</p>
          </li>
          <li>
            <label>产地:</label>
            <p>{{curData.oocql004}}</p>
          </li>
          <li>
            <label>订单数量:</label>
            <p>{{curData.xmdd005}}</p>
          </li>
          <li>
            <label>已转出通量:</label>
            <p>{{curData.xmdd031}}</p>
          </li>

          <li>
            <label>已转出货量(考虑销退数量):</label>
            <p>{{curData.xmdd014}}</p>
          </li>
          <li>
            <label>计划发货数量:</label>
            <p>{{curData.planNum}}</p>
          </li>
          <li>
            <label>计划发货日期:</label>
            <p>{{curData.planDate}}</p>
          </li>
          <li>
            <label>计划响应时间:</label>
            <p>{{curData.planFeedbackTime}}</p>
          </li>
          <li>
            <label>计划负责人:</label>
            <p>{{curData.principal}}</p>
          </li>
          <li>
            <label>预计发货日期:</label>
            <p>{{curData.planDeliveryTime}}</p>
          </li>
          <li>
            <label>修正发货日期:</label>
            <p>{{curData.actualDeliveryTime}}</p>
          </li>
          <li>
            <label>工单号:</label>
            <p>{{curData.sfaadocno}}</p>
          </li>
          <li>
            <label>单据日期:</label>
            <p>{{curData.sfaadocdt}}</p>
          </li>
          <li>
            <label>生管人员:</label>
            <p>{{curData.oofa011}}</p>
          </li>
          <li>
            <label>预计开工日期:</label>
            <p>{{curData.sfaa019}}</p>
          </li>
          <li>
            <label>预计完工日期:</label>
            <p>{{curData.sfaa020}}</p>
          </li>
          <li>
            <label>生产数量:</label>
            <p>{{curData.sfaa012}}</p>
          </li>
          <li>
            <label>已入库合格量:</label>
            <p>{{curData.sfaa050}}</p>
          </li>
          <li>
            <label>最后入库日期:</label>
            <p>{{curData.sfaa046}}</p>
          </li>
        </ul>
        <!-- <p class="title">产品项目组</p> -->

        <!-- <p class="title">计划调度部</p> -->
        <!-- <PlanList :planData="planData"></PlanList> -->
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import XLSX from 'xlsx'
  import FileSaver from 'file-saver'

  import qs from 'qs'
  import PlanList from '../../components/PlanList.vue'

  export default {
    name: 'Serve',
    components: {
      PlanList
    },
    data() {
      return {
        noReport: false,
        tbPop: false,
        tbData: {},
        spanArr: [],
        loading: true,
        dialogVisible: false,
        drawer: false,
        direction: 'ttb',
        activeNames: ['0'],
        formInline: {
          xmdddocno: '',
          xmddseq: '',
          xmddseq1: '',
          principal: '',
          sfaadocno: '',
          statu: '',
          xmddua017: '',
          xmdaua001: '',
          pjabl003: '',
          createder: '',
          daterange: []
        },
        status: [{
            value: '0',
            lable: '未完成'
          },
          {
            value: '1',
            lable: '已完成'
          }
        ],
        tableData: [],
        planData: [],
        curData: {},
        curData01: {
          xmdcua004: '',
          xmdcua018: '',
          xmddud001: '',
          planNum: '',
          planDate: '',
          remark: ''
        },
        rule01: {
          xmdcua004: [{
            required: true,
            message: '请输入',
            trigger: 'change'
          }],
          xmdcua018: [{
            required: true,
            message: '请输入',
            trigger: 'blur'
          }],
          xmddud001: [{
            required: true,
            message: '请输入',
            trigger: 'change'
          }],
          planNum: [{
            required: true,
            message: '请输入',
            trigger: 'blur'
          }],
          planDate: [{
            required: true,
            message: '请输入',
            trigger: 'change'
          }],
          remark: [{
            required: true,
            message: '请输入',
            trigger: 'blur'
          }]
        },
        page: 1,
        rows: 10,
        total: null,
        supplyTypes: ['自产（合肥）', '自产（烟台）', '自产（丹阳）', '合作'],
        places: [{
            value: 'HF01',
            lable: '合肥园区'
          },
          {
            value: 'HF02',
            lable: '合肥外厂'
          },
          {
            value: 'ZX01',
            lable: '正信烟台'
          },
          {
            value: 'ZX02',
            lable: '正信东方'
          },
          {
            value: 'ZX03',
            lable: '正信长仪'
          },
          {
            value: 'HZXM',
            lable: '合作项目'
          },
          {
            value: '0',
            lable: '无'
          }
        ],
      }
    },
    mounted() {
      this.getList()
    },
    methods: {
      reportTable() {
        this.noReport = true
        this.asyncGetList()
      },
      async asyncGetList() {
        this.rows = -1
        await this.getListAll()
        this.exportExcel('三周报表')
        this.noReport = false
        this.rows = 10
        this.page = 1
        this.tableData.splice(10)
      },
      exportExcel(excelName) {
        try {
          const $e = this.$refs['report-table'].$el;
          let $table = $e.querySelector('.el-table__fixed');
          if (!$table) {
            $table = $e;
          }
          // 为了返回单元格原始字符串，设置{ raw: true }
          const wb = XLSX.utils.table_to_book($table, {
            raw: true
          });
          const wbout = XLSX.write(wb, {
            bookType: 'xlsx',
            bookSST: true,
            type: 'array'
          });
          FileSaver.saveAs(
            new Blob([wbout], {
              type: 'application/octet-stream'
            }), `${excelName}.xlsx`)
        } catch (e) {
          if (typeof console !== 'undefined') console.error(e);
        }
      },
      getSpanArr(data) {
        // data就是我们从后台拿到的数据
        for (var i = 0; i < data.length; i++) {
          if (i === 0) {
            this.spanArr.push(1);
            this.pos = 0;
          } else {
            // 判断当前元素与上一个元素是否相同
            if (data[i].xmdddocno === data[i - 1].xmdddocno) {
              this.spanArr[this.pos] += 1;
              this.spanArr.push(0);
            } else {
              this.spanArr.push(1);
              this.pos = i;
            }
          }
          // console.log(this.spanArr);
        }
      },
      objectSpanMethod({
        row,
        column,
        rowIndex,
        columnIndex
      }) {
        if (columnIndex === 9 || columnIndex === 10 || columnIndex === 11) {
          const _row = this.spanArr[rowIndex];
          const _col = _row > 0 ? 1 : 0;
          // console.log(`rowspan:${_row} colspan:${_col}`);
          return {
            // [0,0] 表示这一行不显示， [2,1]表示行的合并数
            rowspan: _row,
            colspan: _col
          };
        }
      },
      getList(e) {
        this.loading = true
        if (e === 'search') {
          this.page = 1
        }
        this.$axios.post('/three-week/findAllMessage', {
          current: this.page,
          size: this.rows,
          ...this.formInline
        }, {
          timeout: 15000
        }).then(res => {
          this.loading = false
          this.tableData = res.data.data.records
          this.total = res.data.data.total
          this.spanArr = []
          this.getSpanArr(this.tableData)
        }).catch(err => {
          this.loading = false
          // this.$message.error('加载失败，请稍候再试。')
        })
      },
      async getListAll() {
        this.loading = true
        await this.$axios.post('/three-week/findAllMessageToExcle', {
          current: this.page,
          size: this.rows,
          ...this.formInline
        }, {
          timeout: 15000
        }).then(res => {
          this.loading = false
          this.tableData = res.data.data.records
          this.total = res.data.data.total
          this.spanArr = []
          this.getSpanArr(this.tableData)
        }).catch(err => {
          this.loading = false
          // this.$message.error('加载失败，请稍候再试。')
        })
      },
      handleCurrentChange(val) {
        this.page = val
        this.getList()
      },
      seeDetail(data) {
        this.dialogVisible = true
        this.curData = data
      },
      onSearch(e) {
        this.getList(e)
      },
      subCont(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$axios.post('/three-week/save', this.curData01).then(res => {
              this.dialogVisible = false
              this.$message({
                message: '添加成功',
                type: 'success'
              })
            })
          } else {
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      handleClose() {
        // this.resetForm('curData01')
        // this.resetForm('curData02')
        // this.curData02.threeWeekId = ''
      }
    }
  }
</script>

<style scoped>
  .demo-form-inline {
    display: flex;
    flex-wrap: wrap;
  }
  .demo-form-inline >>> .el-form-item {
    width: 200px;
  }
  .demo-form-inline>div:nth-of-type(1) {
    width: 300px !important;
    margin-right: 10px !important;
  }
  .el-date-editor.el-input__inner[data-v-361bf44e] {
    width: 200px;
  }
  .el-table {
    box-sizing: border-box;
  }

  .drawer-cont {
    box-sizing: border-box;
    padding: 0 20px;
  }

  .el-tag {
    /* cursor: pointer; */
  }

  .el-table>>>.cell .el-button {
    padding: 0;
  }

  /*  .el-dialog__wrapper {
    height: 100%;
  }
  .el-dialog__wrapper >>> .el-dialog {
    height: 80%;
    overflow-y: auto;
  } */
  .cont-box {
    padding: 0 10px;
    height: 100%;
    overflow-y: auto;
  }

  .list-cont {
    display: flex;
    flex-wrap: wrap;
    margin: 0 1em;
    padding: 14px 0;
  }

  .list-cont01 {
    display: flex;
    flex-wrap: wrap;
    margin: 0 1em;
    padding: 14px 0;
  }

  .list-cont li {
    box-sizing: border-box;
    width: 25%;
    display: flex;
    padding: 12px 6px;
    align-items: center;
  }

  .list-cont01>div {
    width: 25%;
    display: flex;
    padding: 6px 0;
    align-items: center;
    margin-bottom: 0;
  }

  .title {
    line-height: 34px;
    background: #f9f9f9;
    text-indent: 1em;
    color: #999999;
  }

  .list-cont li>label {
    color: #646464;
    white-space: nowrap;
  }

  .list-cont01>div>>>.el-form-item__label {
    white-space: nowrap;
  }

  .list-cont01>div>>>.el-form-item__content {
    flex: 1;
    margin: 0 1em 0 .5em;
  }

  .list-cont li>p {
    flex: 1;
    color: #323232;
    margin: 0 10px;
    min-height: 20px;
    border-bottom: 1px solid #dedede;
  }

  .list-cont li>.el-input,
  .list-cont li>.el-select,
  .list-cont li>.el-textarea {
    flex: 1;
    margin: 0 1em 0 .5em;
  }

  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 100%;
  }

  .el-select {
    width: 100%;
  }

  .el-table>>>.el-table__fixed,
  .el-table>>>.el-table__fixed-right {
    bottom: 0 !important;
  }
</style>
